import { AppService } from '../services/app.service';
import { Injectable, OnInit } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { AppLanguage } from './app.language';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthenticationService implements OnInit {

    public redirectUrl: string;
    public user: any = {};
    private headers: Headers;
    private options: RequestOptions;
    private tokenEndpoint: string;
    private clientId: string;

    ngOnInit(): void {
    }

    constructor(
        private http: Http,
        private appService: AppService,
        private language: AppLanguage,
        private location: Location,
        private router: Router
    ) {
        this.decodeToken();

        this.tokenEndpoint = `${this.appService.apiRoot}/Token`;
        this.clientId = null;
    }

    getUser(): any {
        const result = localStorage.getItem('userInformation5S');
        if (result) {
            this.user = JSON.parse(result);
        }

        return this.user;
    }

    public async doSignIn(userName: string, password: string) {

        this.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        this.headers.set('Accept-Language', this.language.get());
        this.options = new RequestOptions({ headers: this.headers });

        const params: any = {
            client_id: this.clientId,
            grant_type: 'password',
            username: userName,
            password
        };

        const body: string = this.encodeParams(params);

        const result = await this.appService.doPOSTOPTION('Token', body, this.options);
        if (result.access_token) {
            this.store(result);
            return {
                Status: 1
            };
        } else {
            return {
                Status: 0,
                Msg: result.error_description
            };
        }
    }

    doSignout(): void {

        this.redirectUrl = null;

        if(localStorage.getItem('userInformation5S') != null) {
            const user = localStorage.getItem('userInformation5S');
            var userinfo = JSON.parse(user);
            const dataRequest = {
                LoginID: (userinfo.LoginID)?userinfo.LoginID:""
            };
            const result = this.appService.doGET('api/User/Logout', dataRequest);
        }
        
        localStorage.removeItem('userInformation5S');
        this.user = {};
        const result = localStorage.getItem('userInformation5S');
        this.revokeToken();
    }

    public getNewToken(): void {

        const refreshToken: string = localStorage.getItem('refresh_token');

        if (refreshToken) {
            const params: any = {
                client_id: this.clientId,
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            };

            const body: string = this.encodeParams(params);

            this.http.post(this.tokenEndpoint, body, this.options)
                .subscribe(
                    (res: Response) => {

                        const loginInfo: any = res.json();

                        if (typeof loginInfo.access_token !== 'undefined') {
                            this.store(loginInfo);
                        }
                    });
        }
    }

    public revokeToken(): void {

        const token: string = localStorage.getItem('token');
        if (token != null) {
            localStorage.removeItem('token');
            // const revocationEndpoint: string = this.tokenEndpoint;

            // const params: any = {
            //     client_id: this.clientId,
            //     token_type_hint: 'access_token',
            //     token
            // };

            // const body: string = this.encodeParams(params);

            // this.http.post(revocationEndpoint, body, this.options)
            //     .subscribe(
            //         () => {

            //         });
        }
    }

    public revokeRefreshToken(): void {

        const refreshToken: string = localStorage.getItem('refresh_token');

        if (refreshToken) {
            const params: any = {
                client_id: this.clientId,
                token_type_hint: 'refresh_token',
                token: refreshToken
            };

            const body: string = this.encodeParams(params);

            this.http.post(this.tokenEndpoint, body, this.options)
                .subscribe(
                    () => {
                        localStorage.removeItem('refresh_token');
                    });
        }
    }

    encodeParams(params: any): string {

        let body = '';
        // tslint:disable-next-line:prefer-const
        // tslint:disable-next-line:forin
        for (const param in params) {
            if (body.length) {
                body += '&';
            }
            body = `${body}${param}=`;
            body = `${body}${encodeURIComponent(params[param])}`;
        }

        return body;
    }

    store(body: any): void {
        // Stores access token in local storage to keep user signed in.
        localStorage.setItem('token', body.access_token);
        // Stores refresh token in local storage.
        localStorage.setItem('refresh_token', body.refresh_token);
        this.setUser(body);
        // Decodes the token.
        this.decodeToken();

    }

    setUser(data: any) {
        if (!data.FilePath ||
            (data.FilePath.indexOf('.png') < 0
            && data.FilePath.indexOf('.jpg') < 0
            && data.FilePath.indexOf('.jpeg') < 0
            && data.FilePath.indexOf('.gif') < 0
            && data.FilePath.indexOf('.bmp') < 0
        )) {
            data.FilePath = 'assets/images/userlogo.png';
        }
        localStorage.setItem('userInformation5S', JSON.stringify({
            UserName: data.UserName,
            FullName: data.FullName,
            RoleID: data.RoleID,
            RoleName: data.RoleName,
            EmployeeID: data.EmployeeID,
            FilePath: data.FilePath,
            UnitID: data.UnitID,
            LoginID: data.LoginID,
        }));
    }

    decodeToken(): void {

        // if (tokenNotExpired()) {

        //     const token: string = localStorage.getItem('token');

        //     const jwtHelper: JwtHelper = new JwtHelper();
        //     this.user = jwtHelper.decodeToken(token);

        // }
    }
}
